import api from './api';

export interface ModulePermission {
  id: number;
  moduleName: string;
  userGroupId: string;
  userGroupName?: string;
  canRead: boolean;
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
}

export interface CreateModulePermissionRequest {
  moduleName: string;
  userGroupId: string;
  canRead: boolean;
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
}

export interface UpdateModulePermissionRequest {
  canRead: boolean;
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
}

export const modulePermissionsApi = {
  // Get all module permissions
  getModulePermissions: async (): Promise<ModulePermission[]> => {
    const response = await api.get('/api/v1/ModulePermissions');
    return response.data;
  },

  // Get specific module permission
  getModulePermission: async (id: number): Promise<ModulePermission> => {
    const response = await api.get(`/api/v1/ModulePermissions/${id}`);
    return response.data;
  },

  // Get user's permissions
  getUserPermissions: async (userId: string): Promise<ModulePermission[]> => {
    const response = await api.get(`/api/v1/ModulePermissions/user/${userId}`);
    return response.data;
  },

  // Get group's permissions
  getGroupPermissions: async (groupId: string): Promise<ModulePermission[]> => {
    const response = await api.get(`/api/v1/ModulePermissions/group/${groupId}`);
    return response.data;
  },

  // Create new module permission
  createModulePermission: async (request: CreateModulePermissionRequest): Promise<ModulePermission> => {
    const response = await api.post('/api/v1/ModulePermissions', request);
    return response.data;
  },

  // Update module permission
  updateModulePermission: async (id: number, request: UpdateModulePermissionRequest): Promise<void> => {
    await api.put(`/api/v1/ModulePermissions/${id}`, request);
  },

  // Delete module permission
  deleteModulePermission: async (id: number): Promise<void> => {
    await api.delete(`/api/v1/ModulePermissions/${id}`);
  }
};

// Available modules in the system
export const AVAILABLE_MODULES = [
  'Dashboard',
  'Kullanıcı Yönetimi', 
  'Kullanıcı Grupları',
  'Modül Yetkileri',
  'Ürün Yönetimi',
  'Sipariş Yönetimi',
  'Müşteri Yönetimi',
  'Tedarikçi Yönetimi',
  'Stok Yönetimi',
  'Satış Raporları',
  'Finans Raporları',
  'Sistem Ayarları',
  'Audit Logs',
  'Veritabanı Ayarları',
  'Barkod Ayarları'
] as const;

export type ModuleName = typeof AVAILABLE_MODULES[number];
